module.exports = __webpack_public_path__ + "static/media/banner_car_light.353f8e8a.png";